import React, { createContext, useContext } from "react";

import type { SiteData, SiteDataContextValue } from "../types";

const SiteDataContext = createContext<SiteDataContextValue | undefined>(
  undefined,
);

interface SiteDataProviderProps {
  children: React.ReactNode;
  siteData: SiteData;
  setSiteData: SiteDataContextValue["setSiteData"];
}

export const SiteDataProvider = ({
  children,
  siteData,
  setSiteData,
}: SiteDataProviderProps) => {
  return (
    <SiteDataContext.Provider value={{ siteData, setSiteData }}>
      {children}
    </SiteDataContext.Provider>
  );
};

export const useSiteData = (): SiteDataContextValue => {
  const context = useContext(SiteDataContext);
  if (!context) {
    throw new Error("useSiteData must be used within a SiteDataProvider");
  }
  return context;
};
